import React from 'react'
import PropTypes from 'prop-types'

import { Price } from 'components'
import styles from './productBlockPrice.css'

const ProductBlockPrice = ({ price }) => {
  if (!price.retail) {
    return null
  }

  return (
    <div className={styles.price}>
      {price.discounted && [
        <Price
          value={price.retail}
          key={'retailprice'}
          classNames={{
            wrapper: styles.strikethroughPrice,
            bigPrice: styles.bigPrice,
            smallPrice: styles.smallPrice
          }}
        />,
        <Price
          value={price.discounted}
          key={'discountprice'}
          classNames={{
            wrapper: styles.discountPrice,
            bigPrice: styles.bigPrice,
            smallPrice: styles.smallPrice
          }}
        />
      ]}
      {!price.discounted &&
      <Price
        value={price.retail}
        classNames={{
          wrapper: styles.retailPrice,
          bigPrice: styles.bigPrice,
          smallPrice: styles.smallPrice
        }}
      />
      }
    </div>
  )
}

ProductBlockPrice.propTypes = {
  price: PropTypes.shape({
    retail: PropTypes.string,
    discounted: PropTypes.string,
    discountedLoyalty: PropTypes.string
  }).isRequired
}

export default ProductBlockPrice
